import clsx from "clsx";
import { StatusWithIcon } from "@shared/ui";
import { formatMoscowDatetime } from "@shared/utils";
import { JournalVersion } from "../../model/types";
import { IntegrationStatusTag } from "../integration-status-tag";
import { VersionStatusTag } from "../version-status-tag";
import "./version-cards.scss";

interface VersionCardsProps {
  versions: JournalVersion[];
  onVersionClick?: (version: JournalVersion) => void;
}

export const VersionCards = ({ versions, onVersionClick }: VersionCardsProps) => {
  return (
    <div className="version-cards">
      {versions.map((version) => (
        <div
          key={version.versionId}
          className={clsx("version-cards__card", version.status === "OUTDATED" && "version-cards__card--outdated")}
          onClick={() => onVersionClick?.(version)}
        >
          <div className="version-cards__card-header">
            <span className="version-cards__title">
              Версия {version.versionNumber}
            </span>
          </div>

          <div className="version-cards__tags">
            <VersionStatusTag status={version.status} variant="card" />
            {version.recordStatus ? (
              <StatusWithIcon status={version.recordStatus} />
            ) : (
              version.integrationStatus && (
                <IntegrationStatusTag status={version.integrationStatus} />
              )
            )}
          </div>

          {version.responsible && (
            <div className="version-cards__responsible">
              <span className="version-cards__responsible-name">
                {version.responsible.name}
              </span>
              <span className="version-cards__date">
                {formatMoscowDatetime(version.versionDate)}
              </span>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
